import { volunteeringVolunteerImage12 } from 'assets/learning';
import React from 'react';
import { Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const VolunteeringLearningScreen12 = () => {
  const { t } = useTranslation();

  return (
    <>
      <h4 id="step-5-3" className='text-volunteering'>{t('learning.volunteering.volunteer.82')}</h4>
      <p>{t('learning.volunteering.volunteer.83')}</p>
      <p>{t('learning.volunteering.volunteer.84')}</p>
      <div className='box mb-5'>
        <i>
          {t('learning.volunteering.volunteer.85.1')}
          <a href="https://www.youtube.com/watch?v=QGHBq5OEsBM" target='_blank' rel='nooppener noreferrer' className="text-volunteering">{t('learning.volunteering.volunteer.85.2')}</a>
          {t('learning.volunteering.volunteer.85.3')}
          <br />
          {t('learning.volunteering.volunteer.85.4')}
          <ul>
            <li>{t('learning.volunteering.volunteer.85.5')}</li>
            <li>{t('learning.volunteering.volunteer.85.6')}</li>
            <li>{t('learning.volunteering.volunteer.85.7')}</li>
            <li>{t('learning.volunteering.volunteer.85.8')}</li>
          </ul>
        </i>
      </div>
      <Image src={volunteeringVolunteerImage12} width={'100%'} height={400} />
    </>
  )

}

export default VolunteeringLearningScreen12;